import { Component, Inject, Input, OnDestroy } from '@angular/core';

import { licenseActions } from '@src/store/reducers/licenseReducer';
import _ from 'lodash';
import { SetTimeAutoDriftDialogComponent, BackupConfigurationsDialogComponent } from '@app/shared/components/dialogs';
import { projectActions } from '@src/store/reducers/projectReducer';
import { backupsActions } from '@src/store/reducers/backupsReducer';
import { cmsActions } from '@src/store/reducers/cmsReducer';
import { userActions } from '@src/store/reducers/userReducer';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { DialogManagerService, SessionService } from '@src/services';
import { DbTypeService } from '@src/services/dbTypeService';
import { Store } from '@src/store';
import { consts } from '@src/constants/consts';
import { databasesActions } from '@src/store/reducers/databasesReducer';
import { ProcessesHoverViewComponent } from "../pipeline/processesHoverView-ang7/processesHoverView";
import { ViewChild } from "@angular/core";
//import { delay } from 'rxjs/operators';


@Component({
    selector: 'configurationsView',
    template: require('./configurationsView.html'),
    styles: [require('./configurationsView.scss')]
})
export class ConfigurationsViewComponent implements OnDestroy {

    @Input() public projectId: any;
    @ViewChild(ProcessesHoverViewComponent) childRef: ProcessesHoverViewComponent;

    public isAdditionalOptionsCollapsed: boolean = false;
    public editBeforeSave: boolean = false;
    public canEditPackageScripts: boolean = false;
    public projectDataName: string;
    public selectedProjectCMSitem: any;
    public selectedProjectAutoBackupValue: any[] = [];
    public selectedAutoRestoreValue: any[] = [];
    public selectedStorageValue: any[] = [];
    public selectedStorageArray: any[] = []
    public selectedPathArray: any[] = []
    public selectedSizeToKeep: any[] = [];
    public ProjectAutoBackupArray: any[] = [];
    public selectedAutoRestore: any[] = []
    public selectedAmountToKeep: any[] = []
    public unSubscribe: any
    public isCollapsedArray: boolean[] = [];
    public selectedCMSid: number;
    public selectedProject: any;
    public prevProjectData: any;
    public selectedCMSitem: any = { id: null, type: "" };
    public dbTypeFlags = null;
    public isAutoDriftDetectionEnvsSet: boolean;
    public unSubscribeForCMSproject: any;
    public selectedAutoBackup = [];
    public id: number = 1;
    public envTypesInfo = [];
    public envsInfo = [];
    public connectionState: string;
    public continouesErrorCount: number;
    public connectionStatuses = {
        GOOD: "GOOD",
        WARNING: "WARNING",
        BAD: "BAD",
    };
    public sourceControlArchitecture = [{ id: 0, key: "Sandbox" }, { id: 1, key: "Shared" }];
    public sourceControlMergeTempDBMode = [{ id: 0, key: "Use existing DB" }, { id: 1, key: "Create new DB" }];
    public selectedMergeTempDBMode: number = 0;
    public onProcessUpdateReceivedData;
    public m_getEnvTypes;
    public $translate;
    public conflictOptions: any;
    public selectedProjectAutoBackup: any[];
    public unSubscribeEditMode: any;
    public envsNames = [];
    public options = [{ id: 0, name: "Default Settings" }];
    public selectedPath = [];
    public autoRestoreItems: any;
    public storageType: any;
    public CMS: any;
    public projectData: any;
    public autoBackupsItems: any;
    public databaseType: any;
    public htmlConn: any;
    public lastConSettings: any;


    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private sessionService: SessionService,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('dbTypeService') private dbTypeService: DbTypeService,
        @Inject('authorizationService') private authorizationService: any,
        @Inject('$filter') private $filter: any,
        @Inject('$state') private state: any,
        @Inject('jobCompletitionService') private jobCompletitionService: any,
        @Inject('$scope') private $scope: any) {
        this.projectId = $stateParams.id;
        this.$translate = this.$filter('translate');
        this.onProcessUpdateReceivedData = this.jobCompletitionService.onProcessUpdateReceivedData.bind(this);
        this.m_getEnvTypes = this.jobCompletitionService.m_getEnvTypes.bind(this)
    }


    public ngOnInit() {
        for (let i = 0; i < this.options.length; i++) {
            this.isCollapsedArray.push(false)
            this.ProjectAutoBackupArray.push(null)
            this.selectedAutoRestore.push(null)
            this.selectedSizeToKeep.push(null)
            this.selectedAmountToKeep.push(null)
            this.selectedStorageArray.push(null)
            this.selectedPathArray.push(null)
            this.selectedProjectAutoBackupValue.push(null);
            this.selectedAutoRestoreValue.push(null);
            this.selectedStorageValue.push(null);
        }

        this.store.dispatch({
            type: projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
            payload: { projId: this.$stateParams.id }
        })
            .then(() => {
                const envsData = this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus;
                if (envsData) {
                    envsData.forEach(envType => {
                        if (envType.name !== "DryRun") {
                            //this.envAndTypes.push({name: envType.name, id: envType.id});
                            this.envTypesInfo.push({ name: envType.name, id: envType.id });
                            if (envType && envType.environments) {
                                envType.environments.forEach(env => {
                                    if (env.name !== "Release Source")
                                        this.envsInfo.push({ name: env.name, id: env.id, envTypeId: env.environmentTypeId });
                                })
                            }
                        }
                    })

                    this.updateBackupRestoreSettings();
                }
            }, (error) => console.error(error));


        this.store.dispatch({ type: projectsActions.GET_CONFLICT_OPTIONS, payload: {} })
            .then(resp => {
                this.conflictOptions = resp;
            })
        this.store.dispatch({ type: backupsActions.GET_BACKUPS_ACTIONS, payload: {} })
            .then(resp => {
                this.autoBackupsItems = [...resp];
                this.initializeBackupArrays();
            })
        this.store.dispatch({ type: backupsActions.GET_RESTORE_ACTIONS, payload: {} })
            .then(resp => {
                this.autoRestoreItems = [...resp];
                this.initializeBackupArrays();
            })
        this.store.dispatch({ type: backupsActions.GET_STORAGE_TYPES, payload: {} })
            .then(resp => {
                this.storageType = [...resp];
                this.initializeBackupArrays();
            })

        this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.$stateParams.id } }).data;
        this.AfterLoad();

        this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.UpdateScript).then(canEditPackageScripts => {
            setTimeout(() => { this.canEditPackageScripts = canEditPackageScripts; }, 50);
        });

        this.$scope.$watch(() => this.store.getState().project.data, (newVal, oldVal) => {
            if (newVal == null && oldVal == null)
                return;

            this.CMS = (newVal.connectedCmsProject != undefined) && true;

            Object.keys(newVal.options).forEach(key => {
                if (newVal.options[key] === "True" || newVal.options[key] === "true")
                    newVal.options[key] = true;

                if (newVal.options[key] === "False" || newVal.options[key] === "false")
                    newVal.options[key] = false;
            });
            //no if (newVal.projectName === undefined) newVal.projectName = newVal.name;
            if (newVal.name === undefined) newVal.name = oldVal.name;
            if (newVal.projectDesc === undefined) newVal.projectDesc = newVal.description;
            if (this.projectData) {
                this.projectData.additionalOption = newVal.additionalOption;
            }

            this.AfterLoad();
        });

        this.store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
            this.resetUserCanLinkCmsFlag();
            this.store.dispatch({
                type: userActions.USER_CAN_LINK_CMS_TO_PROJECT,
                payload: { userId: res.data.id, projectId: this.$stateParams.id },
                customErrorHandling: true,
                silentRequest: true,
            })
        });

        this.unSubscribeEditMode = this.store.subscribe(() => {
            const proj = this.store.getState().project;
            if (proj.editMode && (!proj.projectBeforeEdit || Object.keys(proj.projectBeforeEdit).length === 0) && this.store.getState().project.data) {
                this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.$stateParams.id } });
                this.store.dispatch({ type: projectActions.SAVE_PROJECT_BEFORE_EDIT, payload: this.store.getState().project.data });
            }
        });


        this.unSubscribe = this.store.subscribe(() => {
            if (this.store.getState().project.editActions &&
                (this.store.getState().project.editActions.state.current.name == 'app.authorized.configurationsView')) {
                this.projectData = this.store.getState().project.data;
                this.AfterLoad();

                this.projectDataName = this.projectData?.name;
                switch (this.store.getState().project.editActions.action) {
                    case 'saveChange': {
                        this.saveChanges();
                        break;
                    }
                    case 'undo': {
                        this.undoChanges();
                        break;
                    }
                    case 'saveDraft': {
                        this.saveDraft();
                        break;
                    }
                    case 'validtion': {
                        break;
                    }
                }

                this.store.dispatch({ type: projectActions.ACTION_CLEAR });
            }
        });

        if (this.store.getState().project.editMode) {
            this.$scope.$watch(() => this.store.getState().project.data, (newVal, oldVal) => {
                if (newVal == null && oldVal == null)
                    return;

                Object.keys(newVal.options).forEach(key => {
                    if (newVal.options[key] === "True" || newVal.options[key] === "true")
                        newVal.options[key] = true;

                    if (newVal.options[key] === "False" || newVal.options[key] === "false")
                        newVal.options[key] = false;
                });
                //no if (newVal.projectName === undefined) newVal.projectName = newVal.name;
                if (newVal.name === undefined) newVal.name = oldVal.name;
                if (newVal.projectDesc === undefined) newVal.projectDesc = newVal.description;
                this.projectData = newVal;

                this.AfterLoad();

                //make sure if there isn't value then going to 20 min
                if (this.projectData)
                    this.projectData.autoDriftDetectionIntervalMintues = this.projectData.autoDriftDetectionIntervalMintues || 20
                //get env types and envs for auto drift
                this.store.dispatch({
                    type: projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
                    payload: { projId: this.$stateParams.id }
                })
                    .then(() => {
                        //  this.envsData = this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus;
                    }, (error) => console.error(error));
            });


            //this.initCMSProject();
        }

        this.$scope.$watch(() => this.store.getState().projects.projectWithMetaData, async (newVal, oldVal) => {
            if (newVal == null)
                return;
            if (this.projectData && this.projectData.environmentTypes) {
                newVal.environmentTypes = this.projectData.environmentTypes;
            }

            if (this.projectData && this.projectData.autoBackupRestoreSettings) {
                setTimeout(() => newVal.autoBackupRestoreSettings = this.projectData.autoBackupRestoreSettings, 0);
                //newVal.autoBackupRestoreSettings = this.projectData.autoBackupRestoreSettings;
            }

            if (this.projectData && this.projectData.autoDriftDetectionEnvTypes.some(evt => evt.order)) {
                setTimeout(() => newVal.autoDriftDetectionEnvTypes = this.projectData.autoDriftDetectionEnvTypes, 0);
            }

            this.CMS = (newVal.connectedCmsProject != undefined) && true;
            //if(this.projectData && this.projectData.connectedCmsProject)
            //{
            //    this.selectedCMSitem = this.store.getState()?.cmss?.cmss.filter(item => item.id == this.projectData.connectedCmsProject.cmsId)[0];
            //    //this.selectedProjectCMSitem = this.store.getState().cmss.projects.filter(item => item.id == this.projectData.connectedCmsProject.id)[0];
            //}
            const projectState = this.store.getState().project;
            if (projectState.editMode
                && projectState.editActions
                && projectState.editActions.action != 'saveChange'
                && projectState.editActions.action != 'undo'
                && projectState.editActions.action != 'saveDraft'
                && projectState.editActions.action != 'validtion'
                && projectState.editActions.action != 'manageEnv') {
                //no if (newVal.projectName === undefined) newVal.projectName = newVal.name;
                if (newVal.name === undefined) newVal.name = oldVal.name;
                if (newVal.projectDesc === undefined) newVal.projectDesc = newVal.description;


            }


            if (!projectState.editMode) {
                this.projectData = newVal;
            }

            this.AfterLoad();

            this.dbTypeFlags = await this.dbTypeService.getFlags(this.projectData.dbTypeId);
            this.prevProjectData = _.cloneDeep(newVal);
            //make sure if there isn't value then going to 20 min
            if (this.projectData)
                this.projectData.autoDriftDetectionIntervalMintues = this.projectData.autoDriftDetectionIntervalMintues || 20;
        });

        //get env types and envs for auto drift
        this.store.dispatch({
            type: projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
            payload: { projId: this.$stateParams.id },
        }).then(() => { }, (error) => console.error(error));

        this.unSubscribe = this.store.subscribe(_ => {
            if (this.store.getState().cmss && this.store.getState().cmss.cmss && this.store.getState().cmss.cmss.length > 0) {
                //  this.cmss = this.store.getState().cmss.cmss;
                this.unSubscribe();
            }
        });

        this.unSubscribeForCMSproject = this.store.subscribe(() => {

            //handle of env types for autoDrift deperecated handle this data as of now come from withMetaData
            if (this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus) {
                const envTypes = [];
                this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus.forEach(envType => {
                    if (envType.name != 'Dev') {
                        envTypes.push(envType);
                    }
                })
                this.setOrderEnvTypes(envTypes);
            }
        });
        this.store.dispatch({ type: cmsActions.GET_ALL_CMS });



        //this.initCMSProject();
        //this.getProjectCMS();
        //if(this.projectData && this.projectData.connectedCmsProject)
        //{
        //    this.selectedCMSitem = this.store.getState()?.cmss?.cmss.filter(item => item.id == this.projectData.connectedCmsProject.cmsId)[0];
        //this.selectedProjectCMSitem = this.store.getState().cmss.projects.filter(item => item.id == this.projectData.connectedCmsProject.id)[0];
        //}
        //this.initCMS()
    }

    updateBackupRestoreSettings() {
        if (this.store.getState().projects.projectWithMetaData) {
            const pref = this.store.getState().projects.projectWithMetaData.autoBackupRestoreSettings.envBackupRestoreSettings;
            if (pref) {
                pref.forEach(env => {
                    if (env.envTypeId)
                        this.addNewBackupSettings(this.envTypesInfo.find(envType => envType.id == env.envTypeId), "envType");
                    else
                        this.addNewBackupSettings(this.envsInfo.find(env2 => env2.id == env.envId), "env");
                })
            }
        }

    }

    public ngOnDestroy() {
        if (this.childRef) {
            this.childRef.ngOnDestroy();
        }
        this.unSubscribe();
    }

    connectionStateUpdate() {
        if (this.continouesErrorCount > 5) {
            this.connectionState = this.connectionStatuses.BAD;
        } else if (this.continouesErrorCount > 0) {
            this.connectionState = this.connectionStatuses.WARNING;
        } else {
            this.connectionState = this.connectionStatuses.GOOD;
        }
    }

    connectionStateReset() {
        this.continouesErrorCount = 0;
        this.connectionStateUpdate();
    }

    connectionStateAddError() {
        this.continouesErrorCount++;
        this.connectionStateUpdate();
    }

    openBackupWindow() {
        // if (this.store.getState().project.editMode) {
        //     this.popUpModal.open({
        //         title: 'Backup And Restore Settings',
        //         template: require('./templates/backupConfigurations.tpl.html'),
        //         windowClass: 'custom-modal-AutoDriftDetectionScope',
        //         buttons: {
        //             OK: { text: "Ok" }
        //         },
        //         contentData: {
        //             envNames: this.envsInfo,
        //             envTypeNames: this.envTypesInfo,
        //             envsForEnvTypeChosen: this.envsInfo,
        //             envsForEnvType(envTypeId) {
        //                 if (this.envTypeNames.length !== 0 && envTypeId) {
        //                     const result = this.envNames.filter(env => {
        //                         return env.envTypeId == envTypeId;
        //                     })
        //                     this.envsForEnvTypeChosen = result;
        //                 }
        //             }

        //         }
        //     }, data => {
        //         if (data.envSelected !== "All")
        //             this.addNewBackupSettings(this.envsInfo.find(env => env.name == data.envSelected), "env")
        //         else
        //             this.addNewBackupSettings(this.envTypesInfo.find(env => env.id == data.envTypeSelected), "envType");
        //     })
        // }
        const onConfirm = (data) => {
            if (data.envSelected !== "All")
                this.addNewBackupSettings(this.envsInfo.find(env => env.name == data.envSelected), "env")
            else
                this.addNewBackupSettings(this.envTypesInfo.find(env => env.id == data.envTypeSelected), "envType");
        };
        const dialogData = {
            title: 'Backup And Restore Settings',
            envSelected: this.envsInfo.length > 0 ? this.envsInfo[0].name : null,
            envTypeSelected: this.envTypesInfo.length > 0 ? this.envTypesInfo[0].id : null,
            envNames: this.envsInfo,
            envTypeNames: this.envTypesInfo,
            envsForEnvTypeChosen: this.envsInfo
        };
        this.dialogManagerService.showDialog(dialogData, onConfirm, BackupConfigurationsDialogComponent, 'backup-configurations');
    }
    initValues(index, action) {
        if (index == 0 && this.projectData && this.projectData.autoBackupRestoreSettings && this.autoBackupsItems && this.autoRestoreItems) {
            if (action == "autoBackup") {
                let temp = this.autoBackupsItems.find(obj => {

                    return obj.Key == this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupBehavior;
                })
                return temp.Value;
            }
            else if (action == "autoRestore") {
                let temp = this.autoRestoreItems.find(obj => {
                    return obj.Key == this.projectData.autoBackupRestoreSettings.backupRestoreSettings.restoreBehavior;
                })
                return temp.Value;
            }
            else if (action == "sizeLimit")
                return this.projectData.autoBackupRestoreSettings.backupRestoreSettings.sizeToKeep !== null ?
                    this.projectData.autoBackupRestoreSettings.backupRestoreSettings.sizeToKeep / 1000000 : "Unlimited"
            else if (action == "amountLimit")
                return this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupsToKeep !== null ?
                    this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupsToKeep : "Unlimited"
            else if (action == "storageType") {
                if (this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupStorageSettings.backupStorageType == "AgentLocalFolder")
                    return "Agent Local Folder";
                else if (this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupStorageSettings.backupStorageType == "FileServer")
                    return "File Server";
            }
            else if (action == "storagePath") {
                //this.selectedPath[index] = this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupStorageSettings.storagePath;
                return this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupStorageSettings.storagePath;
            }
        }
        else if (index !== 0 && this.projectData && this.autoBackupsItems && this.autoRestoreItems) {
            if (this.envTypesInfo.includes(this.options[index])) {
                if
                    (!this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.find(tempEnvBackup => {
                        return this.options[index].id == tempEnvBackup.envTypeId;
                    })
                ) {
                    this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.push
                        ({
                            backupBehavior: null,
                            backupStorageSettings: { backupStorageType: "FileServer" },
                            backupsToKeep: null,
                            envTypeId: this.options[index].id,
                            restoreBehavior: null,
                            sizeToKeep: null
                        })

                }
            }
            else if (this.envsInfo.includes(this.options[index])) {
                if
                    (!this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.find(tempEnvBackup => {
                        return this.options[index].id == tempEnvBackup.envId;
                    })
                ) {
                    this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.push
                        ({
                            backupBehavior: null,
                            backupStorageSettings: { backupStorageType: "FileServer" },
                            backupsToKeep: null,
                            envId: this.options[index].id,
                            restoreBehavior: null,
                            sizeToKeep: null
                        })
                }
            }


            let result: any;
            this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.forEach(env => {
                let check = false;
                if (env.envTypeId)
                    check = env.envTypeId === this.options[index].id;
                else
                    check = env.envId === this.options[index].id;
                if (check) {
                    if (action == "autoBackup") {
                        let temp = this.autoBackupsItems.find(obj => {
                            return obj.Key == env.backupBehavior;
                        })
                        result = temp ? temp.Value : "";
                    }
                    else if (action == "autoRestore") {
                        let temp = this.autoRestoreItems.find(obj => {
                            return obj.Key == env.restoreBehavior;
                        })
                        result = temp ? temp.Value : "";
                    }
                    else if (action == "sizeLimit")
                        result = env.sizeToKeep !== null ? env.sizeToKeep / 1000000 : "Unlimited"
                    else if (action == "amountLimit")
                        result = env.backupsToKeep !== null ? env.backupsToKeep : "Unlimited"
                    else if (action == "storageType") {
                        if (env.backupStorageSettings.backupStorageType == "AgentLocalFolder")
                            result = "Agent Local Folder";
                        else if (env.backupStorageSettings.backupStorageType == "FileServer")
                            result = "File Server";
                    }
                    else if (action == "storagePath") {
                        //this.selectedPath[index] = env.storagePath;
                        result = env.backupStorageSettings.storagePath;
                    }
                }
            })
            return result;
        }
    }

    sendBackValue(index, item, action) {
        if (index == 0) {
            if (action == "autoBackup")
                this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupBehavior = item.Key;

            else if (action == "autoRestore")
                this.projectData.autoBackupRestoreSettings.backupRestoreSettings.restoreBehavior = item.Key;

            else if (action == "storageType")
                this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupStorageSettings.backupStorageType = item.Key;
            else if (action == "sizeLimit") {
                if (item === null)
                    this.projectData.autoBackupRestoreSettings.backupRestoreSettings.sizeToKeep = null;
                else
                    this.projectData.autoBackupRestoreSettings.backupRestoreSettings.sizeToKeep = item * 1000000;
            }
            else if (action == "amountLimit") {
                if (item === null)
                    this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupsToKeep = null
                else
                    this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupsToKeep = item;
            }
            else if (action == "storagePath")
                this.projectData.autoBackupRestoreSettings.backupRestoreSettings.backupStorageSettings.storagePath = item;

        }
        else {
            this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.forEach(env => {
                let check = false;
                if (env.envTypeId)
                    check = env.envTypeId === this.options[index].id;
                else
                    check = env.envId === this.options[index].id;
                if (check) {
                    if (action == "autoBackup")
                        env.backupBehavior = item.Key;
                    else if (action == "autoRestore")
                        env.restoreBehavior = item.Key;
                    else if (action == "storageType")
                        env.backupStorageSettings.backupStorageType = item.Key;
                    else if (action == "sizeLimit")
                        env.sizeToKeep = item * 1000000;
                    else if (action == "amountLimit")
                        env.backupsToKeep = item;
                    else if (action == "storagePath")
                        env.backupStorageSettings.storagePath = item
                }
            })
        }
    }
    addNewBackupSettings(envOrType, type) {
        if (envOrType && !this.options.includes(envOrType) &&
            (((type == 'env' && this.envsInfo.includes(envOrType)) || (type == 'envType' && this.envTypesInfo.includes(envOrType))))) {
            var index = this.options.indexOf(envOrType);
            if (index === -1) {
                this.options.push(envOrType);
                this.isCollapsedArray.push(false);
                this.ProjectAutoBackupArray.push(null);
                this.selectedAutoRestore.push(null);
                this.selectedSizeToKeep.push(null);
                this.selectedAmountToKeep.push(null);
                this.selectedStorageArray.push(null);
                this.selectedPathArray.push(null);
                this.selectedProjectAutoBackupValue.push(null);
                this.selectedAutoRestoreValue.push(null);
                this.selectedStorageValue.push(null);
                this.initializeBackupArrays();
                /*
                // take off the option from the options array
                index = this.envAndTypes.indexOf(envOrType);
                this.envAndTypes.splice(index, 1);
                this.selectedEnvOrType = null;
                */
            }


        }
    }
    deleteContainer(item) {
        var index = this.options.indexOf(item);
        if (index !== -1) {
            let check = '';
            this.options.splice(index, 1);
            let tempBackup = this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.find(envBackup => {
                if (envBackup.envTypeId) {
                    check = 'envType';
                    return envBackup.envTypeId == item.id;
                }
                else {
                    check = 'env';
                    return envBackup.envId == item.id;
                }
            })
            var index2 = this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.indexOf(tempBackup);
            this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.splice(index2, 1);
            if (check == 'envType') {
                this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings =
                    this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.filter(env => {
                        return this.envTypesInfo.map(x => ({ id: x.id })).includes(env.envTypeId)
                    })
            }
            if (check == 'env') {
                this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings =
                    this.projectData.autoBackupRestoreSettings.envBackupRestoreSettings.filter(env => {
                        return this.envsInfo.map(x => ({ id: x.id })).includes(env.envId)
                    })
            }

        }

    }
    $postLink = () => {
        if (this.store.getState().project.editMode && !this.store.getState().project.data) {
            this.store.dispatch({ type: projectActions.GET_EDIT_PROJECT, payload: { projectId: this.projectId } });
        }
    }

    $onDestroy = () => {
        if (!this.store.getState().project.editMode) {
            this.store.dispatch({ type: projectActions.REMOVE_PROJECT_DATA });
            this.store.dispatch({ type: projectActions.REMOVE_PROJECT_BEFORE_EDIT });
        }
    };

    undoChanges() {
        if (this.store.getState().project.projectBeforeEdit) {
            let parentId = this.projectData.parentId;
            this.projectData = { ...this.store.getState().project.projectBeforeEdit };
            if (!this.projectData.parentId)
                this.projectData.parentId = parentId;

            //this.AfterLoad();
        }
        this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.projectData.parentId } }).then;
        this.store.dispatch({ type: projectActions.ACTION_CLEAR, payload: { editMode: false } });
        this.store.dispatch({ type: projectActions.SET_EDIT_MODE, payload: { editMode: false } });

        //delete draft by server - see submenu.js
        if (this.store.getState().project.isNewDraft) {
            this.store.dispatch({
                type: projectActions.SET_EDIT_MODE,
                payload: { editMode: false, isNewDraft: null, isNew: null }
            });
            this.store.dispatch({ type: projectsActions.DELETE_DRAFT, payload: { id: this.state.params.id } });
        }
        this.state.go('app.authorized.configurationsView', { id: this.projectData.parentId, name: this.projectData.name });
    }

    saveDraft() {
        this.projectData.userInitiatedChange = true;
        this.store.dispatch({ type: projectActions.SAVE_DRAFT, payload: { project: this.projectData } }).then((resp) => {
            if (resp.data.validationErrors == null) {
                if (resp.data.projectDraft.id != 0 && (this.projectData == null || this.projectData.id == 0)) {
                    this.projectData = resp.data.projectDraft;
                }
                this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.state.params.id } });
                this.store.dispatch({ type: projectActions.ACTION_CLEAR });
                this.store.dispatch({ type: projectActions.SAVE_PROJECT_BEFORE_EDIT, payload: resp.data.projectDraft });
                this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: resp.data.projectDraft } });
                this.store.dispatch({ type: projectActions.SET_EDIT_MODE, payload: { editMode: true, isNewDraft: false } });

                this.dialogManagerService.showSuccessDialog({ title: this.$translate('SUCCESS_PROJECT_DRAFT_SAVE'), text: '' });
            } else {
                this.dialogManagerService.showErrorDialog({
                    title: this.$translate('ERROR_OCCURRED'),
                    text: resp.data.validationErrors[0]['ErrorMsg'] ?
                        resp.data.validationErrors[0]['ErrorMsg'] : '' //JSON.stringify(resp.data.validationErrors[0]['ErrorMsg']) : ''
                });
            }
        });
    }

    saveChanges() {
        //If Auto Dry Run is not set, don't pass the connection details for it
        if (!this.projectData?.options.AutoGenerateDryRun) {
            this.projectData.autoDryRunConnectionDetails = null;
            this.projectData.autoDryRunConnectionDetailsNoPass = null;
            this.projectData.sourceControlMergeExistingTempDBConnectionDetailsNoPass = null;
        }
        if (this.projectData.CMS && !this.projectData.connectedCmsProject) {
            this.dialogManagerService.showErrorDialog({
                title: this.$translate('ERROR'),
                text: `CMS settings ${this.$translate('ERROR_FIELD_RQUEIRED')}`
            });
        } else {
            this.store.dispatch({
                type: projectActions.COMMIT_PROJECT,
                payload: { project: this.projectData },
                callback: (response) => {
                    if (response.data.validationErrors == null) {

                        //after successful committing the project, a message will appear explaining it
                        this.dialogManagerService.showSuccessDialog(
                            {
                                title: this.$translate('PUBLISH_PROJECT_TITLE'),
                                text: this.$translate('PUBLISH_PROJECT_MSG'),
                            });

                        this.store.dispatch({ type: projectActions.SET_EDIT_MODE, payload: { editMode: false } });
                        this.editBeforeSave = false;
                        this.store.dispatch({ type: projectActions.SAVE_PROJECT_BEFORE_EDIT, payload: this.projectData });
                        this.store.dispatch({ type: projectsActions.GET_PROJECTS });

                        //in case the project is draft without parent - refresh
                        if (!this.projectData.parentId) {
                            this.state.go(this.state.current.name, { id: this.projectData.id, name: this.projectData.name });
                            this.store.dispatch({
                                type: projectActions.SET_EDIT_MODE,
                                payload: { editMode: false, isNew: null, isNewDraft: false }
                            });
                        }
                        else {
                            //remain projectId and not parentId while staying in editmode
                            this.sessionService.set(`project_${this.projectData.id}`, this.projectData.name + ' (Draft)');

                            this.state.go(this.state.current.name, {
                                id: this.projectData.id,
                                name: this.projectData.name + ' (Draft)'
                            });

                            this.store.dispatch({
                                type: projectActions.SET_EDIT_MODE,
                                payload: { editMode: true, isNewDraft: false }
                            });
                        }

                    } else {
                        const errorMessage = response.data.validationErrors[0]['ErrorMsg'];
                        this.dialogManagerService.showErrorDialog({
                            title: this.$translate('ERROR_OCCURRED'),
                            text: errorMessage
                            //text: errorMessage ? JSON.stringify(errorMessage) : ''
                        });
                    }
                }
            }).then(() => {
                this.store.dispatch({ type: licenseActions.GET_LICENSE_WARNINGS });
            });
        }
    }

    setLabel(title) {
        switch (title) {
            case "ByVersion":
                return "Deploy by Versions";
            case "ByTask":
                return "Deploy by Task";
        }
    }

    async getProjectCMS(init = false) {
        let success = true;

        if (this.selectedCMSitem && this.selectedCMSitem.type != 6) {
            if (this.projectData?.connectedCmsProject != null) {
                success = await this.store.dispatch({ type: cmsActions.GET_CMS_PROJECTS, payload: { cmsId: this.selectedCMSitem.id } }).then(() => {
                    if (init)
                        return;
                    if (this.store.getState().cmss && this.store.getState().cmss.projects && this.store.getState().cmss.projects.length >= 1) {
                        //this.selectedProjectCMSitem = this.store.getState().cmss.projects[0];
                        //this.cmsProjectChange(true);
                        //this.setCMSToProject();
                    }
                    return true;
                }, () => { return false; });
            }
        } else {
            //this.setCMSToProject();            
        }
        return success;
    }

    public async AfterLoad() {
        this.selectedCMSitem = null;
        this.selectedProjectCMSitem = null;

        // Sync local selectedMergeTempDBMode from projectData (before any async work)
        if (this.projectData?.options?.SourceControlMergeTempDBMode !== undefined) {
            this.selectedMergeTempDBMode = parseInt(this.projectData.options.SourceControlMergeTempDBMode) || 0;
        }

        if (this.projectData && this.projectData.connectedCmsProject) {
            this.selectedCMSitem = this.store.getState()?.cmss?.cmss.filter(item => item.id == this.projectData.connectedCmsProject.cmsId)[0];
            //console.log(this.selectedCMSitem);
        }
        //console.log("AfterLoad - item : " + this.selectedCMSitem);

        await this.getProjectCMS(false);

        if (this.projectData && this.projectData.connectedCmsProject && this.selectedCMSitem?.type != 6) {
            this.selectedProjectCMSitem = this.store.getState().cmss.projects.filter(item => item.id == this.projectData.connectedCmsProject.id)[0];

        }

        //Set Auto Dry Run test field on load
        if (this.projectData) {
            this.projectData.autoDryRunConnectionDetailsNoPass = this.convertConnectionToString(this.projectData.autoDryRunConnectionDetails);
            this.projectData.sourceControlMergeExistingTempDBConnectionDetailsNoPass = this.convertConnectionToString(this.projectData.sourceControlMergeExistingTempDBConnectionDetails);
        }

        this.initializeBackupArrays();
    }

    public initializeBackupArrays() {
        if (!this.projectData || !this.autoBackupsItems || !this.autoRestoreItems || !this.storageType) return;

        this.options.forEach((_, index) => {
            if (this.selectedProjectAutoBackupValue.length <= index) this.selectedProjectAutoBackupValue.push(null);
            if (this.selectedAutoRestoreValue.length <= index) this.selectedAutoRestoreValue.push(null);
            if (this.selectedStorageValue.length <= index) this.selectedStorageValue.push(null);
            if (this.ProjectAutoBackupArray.length <= index) this.ProjectAutoBackupArray.push(null);
            if (this.selectedAutoRestore.length <= index) this.selectedAutoRestore.push(null);
            if (this.selectedStorageArray.length <= index) this.selectedStorageArray.push(null);

            this.selectedProjectAutoBackupValue[index] = this.initValues(index, 'autoBackup');
            this.selectedAutoRestoreValue[index] = this.initValues(index, 'autoRestore');
            this.selectedStorageValue[index] = this.initValues(index, 'storageType');

            this.ProjectAutoBackupArray[index] = this.autoBackupsItems.find(i => i.Value === this.selectedProjectAutoBackupValue[index]);
            this.selectedAutoRestore[index] = this.autoRestoreItems.find(i => i.Value === this.selectedAutoRestoreValue[index]);
            this.selectedStorageArray[index] = this.storageType.find(i => {
                if (this.selectedStorageValue[index] === "Agent Local Folder") return i.Key === "AgentLocalFolder";
                if (this.selectedStorageValue[index] === "File Server") return i.Key === "FileServer";
                return i.Value === this.selectedStorageValue[index];
            });
        });
    }





    public insertToJson(fieldName: string, value, fieldName2 = null, fieldName3 = null) {
        if (fieldName2 != null || fieldName3 != null) {
            if (fieldName3 != null && this.projectData[fieldName][fieldName2][fieldName3] !== undefined) {
                if (this.projectData[fieldName][fieldName2] == undefined) {
                    this.projectData[fieldName][fieldName2] = {};
                }
                this.projectData[fieldName][fieldName2][fieldName3] = value
            }
            else {
                this.projectData[fieldName][fieldName2] = value

            }
        }
        else {
            this.projectData[fieldName] = value
        }
    }

    public onMergeTempDBModeChange(modeId: number) {
        this.selectedMergeTempDBMode = modeId;
        this.insertToJson('options', modeId, 'SourceControlMergeTempDBMode');
        // Auto-fill the template name when "Create new DB" (mode 1) is selected and template is empty
        if (modeId === 1 && !this.projectData?.options?.SourceControlMergeTempDBNameTemplate) {
            const defaultTemplate = `{DatabaseName}_DBM_TMP`;
            this.insertToJson('options', defaultTemplate, 'SourceControlMergeTempDBNameTemplate');
        }
    }

    getConnectedCMSType() {

        if (this.store.getState().cmss && this.store.getState().cmss.cmss && this.projectData.connectedCmsProject && this.projectData.connectedCmsProject.cmsId) {
            let selectedCms = this.store.getState().cmss.cmss.filter(cms => cms.id == this.projectData.connectedCmsProject.cmsId)[0];

            if (selectedCms) {

                return selectedCms;
            }
        }
    }

    setCMSToProject() {
        this.projectData.connectedCmsProject = {};
        if (!this.selectedCMSitem)
            return;

        if (this.selectedCMSitem.type == 6) {
            if (this.projectData) {
                this.projectData.connectedCmsProject.id = this.projectData.id;
                this.projectData.connectedCmsProject.name = this.projectData.name;
                //this.selectedProjectCMSitem = null;

            }
        } else if (this.selectedProjectCMSitem) {
            this.projectData.connectedCmsProject.id = this.selectedProjectCMSitem.id;
            this.projectData.connectedCmsProject.name = this.selectedProjectCMSitem.name;
        }
        this.projectData.connectedCmsProject.cmsId = this.selectedCMSitem.id
        this.projectData.connectedCmsProject.cmsType = this.selectedCMSitem.type
        this.editBeforeSave = true;
    }

    EditAutoDriftTime() {
        let _times = [
            { minutes: 10, name: "10 Minutes" },
            { minutes: 20, name: "20 Minutes" },
            { minutes: 30, name: "30 Minutes" },
            { minutes: 60, name: "60 Minutes" },
            { minutes: 120, name: "2 Hours" },
            { minutes: 240, name: "4 Hours" },
            { minutes: 480, name: "8 Hours" },
            { minutes: 1440, name: "24 Hours" }
        ];
        const locateSelection = _.find(_times, (item) => {
            return item.minutes == this.projectData.autoDriftDetectionIntervalMintues;
        });
        // this.popUpModal.open({
        //     title: 'Auto Drift Detection Scope',
        //     template: require('./templates/setTimeAutoDrift.tpl.html'),
        //     windowClass: 'custom-modal-AutoDriftDetectionScope',
        //     buttons: {
        //         OK: { text: 'Update' }
        //     },
        //     contentData: {
        //         validTime: (time) => {
        //             if (!time)
        //                 return true;
        //             let regex = /^(\d{2}):(\d{2})$/;
        //             let result = regex.test(time);
        //             if (result) {
        //                 if (time.match(regex)[1] > 12 || time.match(regex)[2] > 59)
        //                     return false;
        //             }
        //             return result;
        //         },
        //         times: _times,
        //         selectedTime: locateSelection
        //     }
        // },
        //     (data) => { this.projectData.autoDriftDetectionIntervalMintues = data.selectedTime.minutes },
        //     () => { });
        const onConfirm = (data) => {
            this.projectData.autoDriftDetectionIntervalMintues = data.selectedTime.minutes
        };
        const dialogData = { title: 'Auto Drift Detection Scope', times: _times, selectedTime: locateSelection };
        this.dialogManagerService.showDialog(dialogData, onConfirm, SetTimeAutoDriftDialogComponent, 'set-time-auto-drift');
    }

    setOrderEnvTypes(envType) {
        if (this.projectData && this.projectData.autoDriftDetectionEnvTypes && envType && envType.length > 0) {
            this.projectData.autoDriftDetectionEnvTypes = this.projectData.autoDriftDetectionEnvTypes.filter(x => x.envTypeId != consts.envTypes.PreRun);
            this.projectData.autoDriftDetectionEnvTypes.forEach(item => {
                envType.forEach(env => {
                    if (item.id == env.id) {
                        item.order = env.order;
                    }
                });
            });
            this.projectData.autoDriftDetectionEnvTypes = _.orderBy(this.projectData.autoDriftDetectionEnvTypes, ['order'], ['asc'])
            this.isAutoDriftDetectionEnvsSet = true;
        }
    }

    setDatabaseType(type) {
        if (type == null) {
            return "NONE"
        }
        if (type >= 0) {
            return this.store.getState().enums.DBTypes.find(item => item.key == type).value;
        }
        return "NONE"
    }

    clearSuperUser() {
        if (!this.projectData.isSuperUser) {
            if (this.projectData) {
                if (this.projectData.environmentTypes) {
                    this.projectData.environmentTypes.forEach(envType => {
                        if (envType.environments)
                            envType.environments.forEach(env => {
                                env.hasSuperUser = false;
                                if (env.schemas)
                                    env.schemas = env.schemas.filter(item => !item.isSuperUser)
                            });
                    });
                }
            }
        }
    }

    enableOrDisableEnvTest() { //disable
        if (!this.projectData.isTest || this.projectData.options.AutoGenerateDryRun) {
            if (this.projectData) {
                if (this.projectData.environmentTypes) {
                    this.projectData.environmentTypes.forEach(envType => {
                        if (envType.id == consts.envTypes.PreRun) {
                            envType.selected = false;
                            envType.environments = []
                            this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: this.projectData } });
                        }
                    });
                }
            }
        } else { //enable
            if (this.projectData) {
                if (this.projectData.environmentTypes) {
                    this.projectData.environmentTypes.forEach(envType => {
                        if (envType.id == consts.envTypes.PreRun) {
                            envType.selected = true;
                            this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: this.projectData } });
                        }
                    });
                }
            }
        }
    }

    canLinkCMS() {
        this.projectData.CMS = this.CMS;

        this.store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
            this.resetUserCanLinkCmsFlag();
            this.store.dispatch({
                type: userActions.USER_CAN_LINK_CMS_TO_PROJECT,
                payload: { userId: res.data.id, projectId: this.projectId },
            }).then(() => { ; }).catch((err) => {
                if (err) { }
                this.resetUserCanLinkCmsFlag();
                this.projectData.hasCMS = null;
                this.selectedCMSitem = null;
                this.selectedProjectCMSitem = null;
                this.projectData.connectedCmsProject = null;
                throw this.$translate('ERROR_USER_AUTH');
            })
        });
    }

    resetUserCanLinkCmsFlag() {
        this.store.dispatch({ type: userActions.REFRESH_USER_CAN_LINK_CMS });
    }



    cancelCMSAction = () => {
        const connectedCmsProject = this.prevProjectData.connectedCmsProject;
        if (connectedCmsProject) {
            this.selectedCMSitem = { id: connectedCmsProject.cmsId, name: connectedCmsProject.cmsTypeName, type: connectedCmsProject.cmsType };
            this.getProjectCMS(true);
            this.selectedProjectCMSitem = this.prevProjectData.connectedCmsProject;
            this.projectData.connectedCmsProject = _.cloneDeep(this.prevProjectData.connectedCmsProject);
        }
    }

    cmsChange = async () => {
        //console.log("before cmsChange " + this.selectedCMSitem);
        await this.setCMSToProject();
        await this.getProjectCMS(false);
        //console.log("after cmsChange " + this.selectedCMSitem);
    }

    initCMS = () => {

        if (!this.CMS) {
            this.selectedCMSid = null;
            this.selectedCMSitem = null;
            this.projectData.connectedCmsProject = null;
        }
        else {

            const cmsType = this.getConnectedCMSType();
            if (cmsType) {
                this.selectedCMSid = cmsType.id;
                this.selectedCMSitem.id = cmsType.id;
                this.selectedCMSitem.type = cmsType;
                this.getProjectCMS(true);
            }
        }
    }

    // check where this function is used
    /*
    initCMSProject = () => {
        if (this.projectData.connectedCmsProject) {
            this.selectedProject = this.projectData.connectedCmsProject.id;
            this.selectedProjectCMSitem = this.projectData.connectedCmsProject;
            this.selectedCMSitem = this.projectData.connectedCmsProject;
            this.setCMSToProject();
        } else {
            this.selectedProject = null;
            this.selectedProjectCMSitem = null;;
        }
    }
    */

    getProjectName = () => {
        if (this.projectData && this.projectData.connectedCmsProject)
            return this.projectData.connectedCmsProject.name
        return null;
    }

    isDegreeOfParallelism = () => {
        let result = false
        if (this.dbTypeFlags && this.dbTypeFlags.HasDevEnv) {
            result = this.projectData.options['BuildParallel'];
        }
        if (this.dbTypeFlags && this.dbTypeFlags.HasValidate) {
            result = result || this.projectData.options['UpdateSourceControlParallel']
                || this.projectData.options['ApplyLabelParallel']
                || this.projectData.options['ValidateParallel'];
        }
        if (this.dbTypeFlags && this.dbTypeFlags.PreRun) {
            result = result || this.projectData.options['BackupRestoreParallel'];
        }

        if (this.projectData && this.projectData.isTest) {
            result = result || this.projectData.options['DryRunParallel'];
        }
        return result
    }

    // True when the current DB type's connection template lacks a DB Name field and
    // we need to inject one for the Merge "Use existing DB" flow. Looked up by name
    // so the check is resilient to dbTypeId reassignment on the server side.
    private mergeRequiresDbNameField(): boolean {
        const dbTypes = this.store.getState()?.enums?.DBTypes;
        if (!dbTypes) { return false; }
        const dbType = dbTypes.find((item: any) => item.key == this.databaseType);
        const name = (dbType?.value || '').toString().toLowerCase();
        return name === 'mssql' || name.indexOf('postgres') !== -1;
    }

    //Open connection details popup
    public connectionDetailsPopup(source?): void {
        if (this.databaseType == undefined) {
            //this.databaseType =  this.projectData.dbTypeId
            this.databaseType = this.projectData.dbTypeId;
        }
        delete this.store.getState().schemas.status_test_schema;
        this.store.dispatch({
            type: 'GET_CONN_TEMPLATE',
            payload: { dbTypeId: this.databaseType, manageOrUnmanage: 'unmanaged' }
        }).then((res) => {
            this.htmlConn = res.htmlTemplate;
            // Inject dbName field for Merge source on DB types whose connection template lacks it.
            // Currently MSSQL and PostgreSQL; Oracle uses identifier/SID instead so it is excluded.
            if (source == 'Merge' && this.mergeRequiresDbNameField()) {
                const dbNameField = `
                    <div style="margin-bottom: 15px;">
                        <b>DB Name</b>
                        <input type="text" class="form-control" style="width: 195px;" [(ngModel)]="data.connectionProperties.dbName" placeholder="Enter DB Name">
                    </div>`;
                // Insert right after the Server Name (host) field's form-group
                const hostFieldRegex = /(connectionProperties\.host[^]*?<\/div>\s*<\/div>)/i;
                const match = this.htmlConn.match(hostFieldRegex);
                if (match) {
                    const insertPos = this.htmlConn.indexOf(match[0]) + match[0].length;
                    this.htmlConn = this.htmlConn.substring(0, insertPos) + dbNameField + this.htmlConn.substring(insertPos);
                } else {
                    this.htmlConn = this.htmlConn + dbNameField;
                }
            }
            this.dialogManagerService.showDBConnectionDialog(
                this.htmlConn,
                {
                    title: "Connection Details",
                    buttons: [
                        {
                            text: 'OK', onClick: (instance, onClose) => {
                                this.handleDBTypeConnectionProperties(instance.data, source);

                                onClose(instance.data);
                            }
                        },
                        {
                            text: 'Cancel', onClick: (_, onClose) => {
                                onClose();
                            }
                        }
                    ],
                    setData: (instance) => {
                        instance.data = {
                            connectionProperties: { host: '', userName: '', password: '', ...(source == 'Merge' ? { dbName: '' } : {}) },
                            //connectionProperties: JSON.parse("{\"host\":\"localhost\",\"userName\":\"system\",\"password\":\"\",\"connectionString\":\"\",\"port\":\"1521\",\"identifierType\":\"SID\",\"identifier\":\"xe\"}"),
                            testButton: {
                                value: 'Test Connection', onClick: (data) => {
                                    this.handleDBTypeConnectionProperties(data, source);

                                    data.status_test_schema = '';
                                    this.testConnection(null, data);
                                }
                            },
                            switchTab: (data, tab) => {
                                this.handleDBTypeConnectionProperties(data, source);

                                if (!data.connectionProperties.lastVisit)
                                    data.connectionProperties.lastVisit = "Properties";
                                this.store.dispatch({
                                    type: 'SWITCH_TAB',
                                    payload: {
                                        dbTypeId: this.databaseType,
                                        connectionProperties: data.connectionProperties
                                    }
                                }).then((res) => {
                                    if (res) {
                                        data.connectionProperties = res;
                                        data.connectionProperties.lastVisit = tab;
                                    }
                                });
                            }
                        };
                        if (source == 'DryRun' || !source) {
                            if (this.projectData.autoDryRunConnectionDetails) {
                                instance.data.connectionProperties = this.projectData.autoDryRunConnectionDetails;
                            }
                        } else if (source == 'Merge') {
                            if (this.projectData.sourceControlMergeExistingTempDBConnectionDetails) {
                                instance.data.connectionProperties = this.projectData.sourceControlMergeExistingTempDBConnectionDetails;
                            }
                            // Restore dbName for DB types where it was injected — falls back to
                            // separately stored value in case it was not present in connectionProperties
                            // (e.g. data saved before this fix).
                            if (this.mergeRequiresDbNameField()) {
                                instance.data.connectionProperties.dbName =
                                    instance.data.connectionProperties.dbName ||
                                    this.projectData.sourceControlMergeExistingTempDBName || '';
                            }
                        }
                    }
                },
                (data) => {
                    const schemaSettings = { ...data };
                    this.handleDBTypeConnectionProperties(schemaSettings, source);

                    this.lastConSettings = schemaSettings;

                    //this.onAddUnmanagedSchemas.emit({ connectionProperties: schemaSettings, isTest : false});
                }
            );
        });
    }
    //Handle special connection string manipulation (TODO: should not be done in that class as this is a a generic handler)
    private handleDBTypeConnectionProperties(info: any, source?) {
        if (this.databaseType === '1') {
            delete info.connectionProperties.port;
            delete info.connectionProperties.identifierType;
            delete info.connectionProperties.identifier;
            info.connectionProperties.authType = info.authType.id;
        }

        if (source == 'Merge') {
            info.connectionProperties.authType = info.authType.id;
            // Keep dbName in connectionProperties so the server-side ConectionPropertiesSet
            // API receives it and can inject it as Initial Catalog into the connection string.
            // Also store it separately so it can be restored when the dialog is reopened.
            if (this.mergeRequiresDbNameField() && info.connectionProperties.dbName) {
                this.projectData.sourceControlMergeExistingTempDBName = info.connectionProperties.dbName;
            }
            this.projectData.sourceControlMergeExistingTempDBConnectionDetails = info.connectionProperties;
            this.projectData.sourceControlMergeExistingTempDBConnectionDetailsNoPass = this.convertConnectionToString(info.connectionProperties);
        } else {
            this.projectData.autoDryRunConnectionDetails = info.connectionProperties;
            this.projectData.autoDryRunConnectionDetailsNoPass = this.convertConnectionToString(info.connectionProperties);
        }
    }

    //Covert connection propertoies to string and remove the password
    convertConnectionToString(connectionDetails: any) {
        if (connectionDetails) {

            let con = JSON.stringify(connectionDetails);
            let copy = JSON.parse(con);
            copy.password = "";
            return JSON.stringify(copy);

        }
    }

    // Format the merge DB connection details as a human-readable string for the read-only view
    formatMergeConnectionForDisplay(connectionDetailsJson: any): string {
        if (!connectionDetailsJson) { return ''; }
        try {
            const props = typeof connectionDetailsJson === 'string'
                ? JSON.parse(connectionDetailsJson)
                : connectionDetailsJson;
            const parts: string[] = [];
            if (props.host) { parts.push(`Server: ${props.host}`); }
            if (props.userName) { parts.push(`User: ${props.userName}`); }
            if (props.dbName) { parts.push(`DB: ${props.dbName}`); }
            else if (this.projectData?.sourceControlMergeExistingTempDBName) {
                parts.push(`DB: ${this.projectData.sourceControlMergeExistingTempDBName}`);
            }
            return parts.length > 0 ? parts.join(' | ') : connectionDetailsJson;
        } catch {
            return connectionDetailsJson;
        }
    }

    //Test connection properties and see that its valid
    testConnection(environment, connectionProps) {
        let payload = {
            environmentId: 0,
            environmentTempId: 0,
            project: this.projectData,
            connectionProperties: connectionProps.connectionProperties
        };
        if (environment) {
            payload.environmentId = environment.id;
            payload.environmentTempId = environment.tempEnvId;
        }

        this.store.dispatch({ type: databasesActions.RESET_SCHEMAS_TEST_CONNECT_STATUS });
        this.store.dispatch({ type: databasesActions.TEST_CONNECT, payload: payload }).then(testStatus => {
            if (testStatus) { }
            if (this.store.getState().schemas.status_test_schema) {
                connectionProps.status_test_schema = this.store.getState().schemas.status_test_schema;
                delete this.store.getState().schemas.status_test_schema;
            }
        });

    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/configurationsView-ang7/configurationsView.ts